import { render } from "./CustomerProfileChangePasswordView.vue?vue&type=template&id=77749f1f&scoped=true&ts=true&lang=pug"
import script from "./CustomerProfileChangePasswordView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerProfileChangePasswordView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerProfileChangePasswordView.vue?vue&type=style&index=0&id=77749f1f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77749f1f"]])

export default __exports__